import { Drawer } from 'components/Drawer'
import { LinkedAccountsDrawerProps } from 'screens/BrandKit/LinkedAccountsDrawer/Types'
import { Panel } from './consts'
import { useRootStore } from 'stores/RootStore'
import { Heading } from 'blaze-ui/Heading/Heading'
import { useLinkedAccountsController } from 'screens/BrandKit/LinkedAccountsDrawer/useLinkedAccountsController'

export const LinkedAccountsDrawer = ({
  brandKitId,
  initialPanel = Panel.SelectAccounts,
  ...props
}: LinkedAccountsDrawerProps) => {
  const { drawersStore } = useRootStore()
  const { closeAllDrawers, closeDrawer } = drawersStore

  const { heading, handleBack, panels } = useLinkedAccountsController({
    brandKitId,
    initialPanel,
    onExit: closeDrawer,
  })

  return (
    <Drawer.Root {...props} activeSnapPoint={1} snapPoints={[1]}>
      <Drawer.Portal>
        <Drawer.Content isSnappedTop fullHeight>
          <Drawer.InnerContent isSnappedTop fullHeight>
            <Drawer.Top>
              <Drawer.Back variant="ghost" onPress={handleBack} position="left">
                Back
              </Drawer.Back>
              <Drawer.Title asChild>
                <Heading level={5} lineClamp={1}>
                  {heading}
                </Heading>
              </Drawer.Title>
              <Drawer.Back variant="ghost" onPress={closeAllDrawers} position="right">
                Cancel
              </Drawer.Back>
            </Drawer.Top>
            <Drawer.Container>{panels}</Drawer.Container>
          </Drawer.InnerContent>
        </Drawer.Content>
        <Drawer.Overlay />
      </Drawer.Portal>
    </Drawer.Root>
  )
}
